module.exports = __webpack_public_path__ + "static/media/How to customize email link template for Invoice Follow-up Email.29a7388e.png";